import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import DayJSUtc from "dayjs/plugin/utc";
import DayJSTimezone from "dayjs/plugin/timezone";
const localizedFormat = require("dayjs/plugin/localizedFormat");

dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(DayJSUtc);
dayjs.extend(DayJSTimezone);

let i18n = null;

export function setI18n(i18nInstance) {
  i18n = i18nInstance;
}

function $t(key) {
  if (!i18n) return key;
  return i18n.t(key);
}

export function formatTextDate(value, format) {
  if (!value) {
    return "";
  }

  if (value.length == "20210415111459".length) {
    return dayjs(value, "YYYYMMDDHHmmss").format(format);
  }

  return dayjs(value).format(format);
}

export function makeFilterFunction(format) {
  return (value) => formatTextDate(value, format);
}

export function compareToday(value, format) {
  if (!value) {
    return "";
  }

  const current = dayjs();
  const postDate = dayjs(value, "YYYYMMDDHHmmss");
  const days = current.diff(postDate, "day");
  const hours = current.diff(postDate, "hour");
  const minutes = current.diff(postDate, "minute");
  const seconds = current.diff(postDate, "second");

  if (days > 2) {
    return formatTextDate(value, "DD/MM/YYYY, h:mm A");
  } else if (days > 0) {
    return `${days} days ago`;
  } else if (hours > 0) {
    return `${hours} hours ago`;
  } else if (minutes > 0) {
    return `${minutes} minutes ago`;
  } else if (seconds > 0) {
    return seconds + " seconds ago";
  }

  return $t("today");
}

export function formatToday(value) {
  if (value == null) {
    return $t("today");
  }

  const today = dayjs();
  const date = dayjs(value);
  const isToday =
    date.isSame(today, "year") &&
    date.isSame(today, "month") &&
    date.isSame(today, "day");

  if (isToday) {
    return $t("today");
  }

  return dayjs(value).format("DD-MM-YYYY");
}

export function isBeforeToday(value) {
  if (!value) return false;

  return dayjs(value).tz("Asia/Saigon").isBefore(dayjs().tz("Asia/Saigon")); // default milliseconds
}
